import Link from '@atlaskit/link';
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  Link,
  SectionMessage,
  React
};